document.addEventListener('DOMContentLoaded', () => {
	const lockScroll = () => {
		document.documentElement.style.overflow = 'hidden'
		document.body.style.overflow = 'hidden'
	}

	const unlockScroll = () => {
		document.documentElement.style.overflow = ''
		document.body.style.overflow = ''
	}

	// Handle clicks on popup trigger links
	document.addEventListener('click', e => {
		const trigger = e.target.closest('[data-popup]')
		if (!trigger) return
		e.preventDefault()
		const popupId = trigger.dataset.popup
		const popup = document.getElementById(popupId)
		if (popup && popup.tagName === 'DIALOG') {
			popup.showModal()
			lockScroll()
		}
	})

	// Handle close buttons inside popups
	document.addEventListener('click', e => {
		const closeBtn = e.target.closest('[data-popup-close]')
		if (!closeBtn) return

		const popup = closeBtn.closest('dialog')
		if (popup) {
			popup.close()
			unlockScroll()
		}
	})

	// Close popup when clicking on backdrop
	document.querySelectorAll('dialog.popup').forEach(dialog => {
		dialog.addEventListener('click', e => {
			if (e.target === dialog) {
				dialog.close()
				unlockScroll()
			}
		})

		// Also handle ESC key close
		dialog.addEventListener('close', () => {
			unlockScroll()
		})
	})
})
